export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //$('.eolia_search_fields input').attr('placeholder','');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js